<template>
  <div
    class="ltcs-claim-prefer-notice"
    :class="{ 'ltcs-claim-prefer-notice--pairs': hasPairs }"
  >
    <v-icon size="18">mdi-information-outline</v-icon>
    <div class="ltcs-claim-prefer-notice__body">
      <p v-if="hasPairs" class="ltcs-claim-prefer-notice__title">
        자동가져오기가 두 번 된 것이 아닙니다
      </p>
      <p class="ltcs-claim-prefer-notice__text">
        롱텀케어 포털은 같은 방문을
        <span class="ltcs-claim-prefer-notice__status">청구의뢰</span>와
        <span class="ltcs-claim-prefer-notice__status ltcs-claim-prefer-notice__status--paid">지급</span>
        두 줄로 보여 줍니다.
        <template v-if="hasPairs">
          포털 원본 {{ formatCount(portalRawCount) }}줄 중 같은 방문
          {{ formatCount(statusPairCount) }}건은 지급만 남겼습니다.
          아래 목록·수가 합계는 방문 {{ formatCount(displayCount) }}건입니다.
        </template>
        <template v-else>
          둘 다 있으면 지급만 집계합니다. 아래 숫자는 방문 기준입니다.
        </template>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    portalRawCount?: number;
    displayCount?: number;
    statusPairCount?: number;
  }>(),
  {
    portalRawCount: 0,
    displayCount: 0,
    statusPairCount: 0,
  }
);

const hasPairs = computed(() => Number(props.statusPairCount) > 0);

const formatCount = (value?: number) => Number(value || 0).toLocaleString();
</script>
